import '../../i18n';
import {useTranslation} from 'react-i18next';
import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { IoMdClose } from 'react-icons/io';
import { GREEN, WHITE } from '../../appearance/Colors';

const PromoCodeBanner = () => {
    const {t: lnT} = useTranslation();

    const location = useLocation();
    const [promoCode, setPromoCode] = useState(null);
    const [isDismissed, setIsDismissed] = useState(false);

    useEffect(() => {
        // Check URL parameters first (supports both 'promocode' and 'coupon' for flexibility)
        const urlParams = new URLSearchParams(location.search);
        const promoCodeFromUrl = urlParams.get('promocode') || urlParams.get('coupon') || urlParams.get('promo');
        
        // Check localStorage for saved promo code
        const savedPromoCode = localStorage.getItem('promoCode');
        
        // Check if banner was dismissed for this promo code
        const dismissedPromoCode = localStorage.getItem('dismissedPromoCode');
        
        // Priority: URL param > localStorage > empty
        const promoCodeToUse = promoCodeFromUrl || savedPromoCode;
        
        // Only show if we have a promo code and it hasn't been dismissed
        if (promoCodeToUse && promoCodeToUse !== dismissedPromoCode) {
            setPromoCode(promoCodeToUse);
            // Add class to body to adjust header position
            document.body.classList.add('promo-banner-visible');
        } else {
            setPromoCode(null);
            // Remove class when banner is hidden
            document.body.classList.remove('promo-banner-visible');
        }
        
        // Cleanup on unmount
        return () => {
            document.body.classList.remove('promo-banner-visible');
        };
    }, [location.search]);

    const handleDismiss = () => {
        setIsDismissed(true);
        // Save dismissed promo code to localStorage so it doesn't show again
        if (promoCode) {
            localStorage.setItem('dismissedPromoCode', promoCode);
        }
        // Remove class when banner is dismissed
        document.body.classList.remove('promo-banner-visible');
    };

    if (!promoCode || isDismissed) {
        return null;
    }

    return (
        <div style={{
            position: 'relative',
            width: '100%',
            backgroundColor: GREEN,
            color: WHITE,
            padding: '12px 16px',
            textAlign: 'center',
            fontSize: '14px',
            fontWeight: '600',
            zIndex: 1001,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '8px',
            boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)'
        }}>
            <span>{lnT('billing:promoCode')}<strong style={{ textTransform: 'uppercase', letterSpacing: '0.1em' }}>{promoCode}</strong>{lnT('billing:applied')}</span>
            <button
                onClick={handleDismiss}
                style={{
                    position: 'absolute',
                    right: '16px',
                    background: 'transparent',
                    border: 'none',
                    color: WHITE,
                    cursor: 'pointer',
                    padding: '4px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    opacity: 0.8,
                    transition: 'opacity 0.2s ease'
                }}
                onMouseOver={(e) => e.target.style.opacity = '1'}
                onMouseOut={(e) => e.target.style.opacity = '0.8'}
                aria-label={lnT('billing:dismissBanner')}
            >
                <IoMdClose size={20} />
            </button>
        </div>
    );
};

export default PromoCodeBanner;

